import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
declare var jQuery: any;
@Component({
  selector: 'app-revolution-slider-db',
  templateUrl: './revolution-slider-db.component.html',
  styleUrls: ['./revolution-slider-db.component.scss']
})
export class RevolutionSliderDbComponent implements OnInit {
  pageLink=''
  constructor(
    private router: Router,
    public route:ActivatedRoute
  ) { }

  ngOnInit(): void {
    let fullType = window.location.href.split('/')
    let type = fullType[3]
    this.pageLink = type;
  }

  ngAfterViewInit(): void {
    jQuery(document).ready(function() {
      jQuery("#rev_slider_6_1").show().revolution({
        jsFileLocation: "js/",
        sliderLayout: 'fullwidth',
        visibilityLevels: '1240,1024,778,480',
        gridwidth: '1400,1024,767,479',
        gridheight: '900,700,500,400',
        minHeight: '',
        autoHeight: true,
        lazyType: 'smart',
        spinner: 'spinner0',
        editorheight: '900,700,500,400',
        responsiveLevels: '1240,1024,778,480',
        disableProgressBar: 'on',
        navigation: {
            mouseScrollNavigation: false,
            touch: {
                touchenabled: true
            }
        },
        parallax: {
            levels: [1, 2, 3, 4, 5, 30, 35, 40, 45, 46, 47, 48, 49, 50, 51, 55],
            type: 'mouse'
        },
        fallbacks: {
            allowHTML5AutoPlayOnAndroid: true
        }
      });
    })
  }
  navigateToPricing() {
    this.router.navigate(['/pricing-plan/', this.pageLink]);
  }


}

